import {
  AddressActionTypes,
  fetchAddressFailure,
  FetchAddressRequestAction,
  fetchAddressSuccess,
} from "actions";
import { IAccount } from "interfaces/account.interface";
import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiBaseUrl } from "utils";

const fetchAddressApi = async (address: string) => {
  const response = await fetch(ApiBaseUrl + `/api/address/${address}`);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

// Worker Saga
function* fetchAddressData(action: FetchAddressRequestAction): SagaIterator {
  try {
    const { address } = action.payload;
    const response: IAccount = yield call(fetchAddressApi, address);
    yield put(fetchAddressSuccess(response));
  } catch (error: any) {
    yield put(fetchAddressFailure(error.message || "Unknown error occurred"));
  }
}

// Watcher Saga
export function* watchAddressSaga() {
  yield takeLatest(AddressActionTypes.FETCH_ADDRESS_REQUEST, fetchAddressData);
}
